import { render, staticRenderFns } from "./DownloadPreview.vue?vue&type=template&id=df12999c&"
import script from "./DownloadPreview.vue?vue&type=script&setup=true&lang=js&"
export * from "./DownloadPreview.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports